/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { CsMasterFilterDto, CSMasterListItemDto } from '@gh/builder-shared-data';

export type CSMasterFinderFilter = CsMasterFilterDto;
export type CSMasterFinderListItem = CSMasterListItemDto;

export const getCSMasterFinderListItemId = (item: CSMasterFinderListItem) => item.id;
